// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"containerDetails_wrapper__27Pex","qrDiv":"containerDetails_qrDiv__70s0s","history":"containerDetails_history__3Vj7B"};